/**
 * ReseauLayout - Layout principal pour le mode Réseau (Abracadaworld)
 * 
 * Structure SIMPLE pour garantir le scroll sur mobile
 * Desktop: Affiche le header global (UnifiedHeader + MainNavigation) + Bandeau Bêta
 */

import { Outlet, useLocation } from 'react-router-dom';
import { useState } from 'react';
import ReseauHeader from '../layout/ReseauHeader';
import UnifiedHeader from '../layout/UnifiedHeader';
import MainNavigation from '../layout/MainNavigation';
import { AdSidebarLeft, AdSidebarRight } from '../ads/AdBannerSystem';

// Bandeau bêta supprimé
function ReseauBetaBanner() {
  return null;
}

export default function ReseauLayout() {
  const location = useLocation();
  const [activeFilter, setActiveFilter] = useState('tous');
  
  // Déterminer si on doit afficher les filtres
  const showFilters = ['/', '/reseau', '/reseau/trending', '/reseau/actus'].some(
    path => location.pathname === path || location.pathname === '/reseau/'
  );
  
  // Masquer le header sur la page Messages (elle a son propre header)
  const hideHeader = location.pathname.startsWith('/reseau/messages');
  
  // Filtres du réseau
  const filters = [
    { id: 'tous', label: 'Tous' },
    { id: 'mes_pros', label: 'Mes pros' },
    { id: 'metier', label: 'Métier' },
    { id: 'tendances', label: 'Tendances' },
  ];
  
  return (
    <>
      {/* ═══ BANDEAU BÊTA DESKTOP ═══ */}
      {!hideHeader && <ReseauBetaBanner />}
      
      {/* ═══ HEADER DESKTOP - UnifiedHeader + MainNavigation ═══ */}
      {!hideHeader && (
        <div className="hidden lg:block">
          <UnifiedHeader />
          <MainNavigation />
          {/* Spacer pour le header fixe */}
          <div style={{ height: '100px' }} />
        </div>
      )}
      
      {/* ═══ HEADER MOBILE - ReseauHeader (mode Réseau spécifique) ═══ */}
      {!hideHeader && (
        <div className="lg:hidden">
          <ReseauHeader />
        </div>
      )}
      
      {/* Filtres - Uniquement sur la page principale du feed (mobile/tablet) */}
      {showFilters && !hideHeader && (
        <div className="sticky top-[88px] z-40 bg-white border-b border-gray-100 lg:hidden">
          <div className="flex items-center justify-center gap-2 py-3 px-4">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  activeFilter === filter.id
                    ? 'bg-[#1E3A5F] text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
                data-testid={`reseau-filter-${filter.id}`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>
      )}
      
      {/* Contenu principal */}
      <Outlet context={{ activeFilter, setActiveFilter }} />
      
      {/* Bannières publicitaires Desktop */}
      <AdSidebarLeft />
      <AdSidebarRight />
      
      {/* Padding pour le bottom nav - Mobile/Tablet uniquement */}
      {!hideHeader && <div className="h-20 lg:hidden" />}
    </>
  );
}
